var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headline-row"},[(_vm.fileName && _vm.fileName !== '')?_c('span',{staticClass:"headline-content"},[_vm._v("\n      "+_vm._s(_vm.fileName)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }